module.exports = __webpack_public_path__ + "img/Computer-troubleshooting-rafiki.e2956415.png";